<template>
  <listbox-option
    v-for="i in quantityAvailable"
    :key="i"
    v-slot="{ active }"
    :value="i"
    as="template"
    :disabled="disabled"
    @click="quantity = i"
  >
    <li
      :class="[
        active ? 'bg-gray-100' : 'text-gray-900',
        'cursor-default select-none relative py-2 pl-3 pr-9',
      ]"
    >
      <span class="text-[0.9rem]">{{ i }}</span>
    </li>
  </listbox-option>
</template>

<script setup>
import { ListboxOption } from '@headlessui/vue';
import useProduct from '../../uses/useProduct';

const { quantity } = useProduct();

defineProps({
  quantityAvailable: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
});
</script>
